import '.f{width:100%;}.ssr-plugin'
import '.am{height:100%;}.ssr-plugin'
import '.h5{max-height:100%;}.ssr-plugin'
import { forwardRef, useEffect, useRef } from 'react'
import { Style, styled } from 'inlines'
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react'
import { useTheme } from '../../hooks/useTheme.js'
import { PartialOptions } from 'overlayscrollbars'

export type ScrollAreaProps = {
  children: React.ReactNode
  style?: Style
  onScroll?: React.UIEventHandler<HTMLDivElement>
  scrollbars?: PartialOptions['scrollbars']
  onViewportChange?: (el: HTMLDivElement | null) => void
}

export const ScrollArea = forwardRef<HTMLDivElement, ScrollAreaProps>(
  (
    {
      children,
      style,
      onScroll,
      scrollbars,
      onViewportChange,
    }: ScrollAreaProps,
    ref,
  ) => {
    return (
      <div className="f am h5"
        // @ts-ignore
        ref={ref}
      >
        <OverlayScrollbarsComponent
          style={{
            width: '100%',
            height: '100%',
            maxHeight: '100%',
            maxWidth: '100%',
            flex: 1,
            overflow: 'auto',
            borderRadius: 'inherit',
            ...style,
          }}
          options={{
            scrollbars: {
              visibility: 'visible',
              ...scrollbars,
            },
          }}
          defer
          events={{
            initialized: (instance) => {
              const viewport = instance?.elements()?.viewport as
                | HTMLDivElement
                | undefined

              onViewportChange?.(viewport ?? null)
            },
            scroll: (_instance, e) => {
              if (onScroll) {
                // @ts-ignore
                onScroll(e)
              }
            },
            destroyed: () => {
              onViewportChange?.(null)
            },
          }}
        >
          {children}
        </OverlayScrollbarsComponent>
      </div>
    )
  },
)
